// pages/dashboard/Main.jsx
import HomeDashBoard from "./HomeDashBoard";
import Operations from "./Operations";
import Structure from "./Structure";
import { useOutletContext } from "react-router-dom";
function DashboardMain(props) {
  const { profile, theme } = useOutletContext();
  const components = {
    hosting: <Operations profile={profile} />,
    structure: <Structure profile={profile} />,
  };

  const Component = components[props.component || "home"];

  return Component || <HomeDashBoard />;
}

export default DashboardMain;
